<template>
  <div class="autocomplete-address-field-wrapper">
    <input
        aria-label="Standorteingabe"
        type="text"
        name="address"
        ref="autocomplete"
        :placeholder="inputplaceholder"
        class="form-control glasfaser-standort-autocomplete min-w-full hidden"
        autocorrect="off"
        autocapitalize="off"
        autocomplete="nope"
        spellcheck="false"
        required
      />
    <i class="status fad fa-check text-green" v-show="addressValid == true & adressObjectId != null"></i>
    <i class="status fad fa-exclamation text-red-700" v-show="!addressValid"></i>
    <input name="adressobjekt" :value="adressObjectId" type="hidden" class="hidden" required>
  </div>
</template>

<script>
import autoComplete from "@tarekraafat/autocomplete.js";

export default {
    props: {
        addressObjectId: String,
        inputplaceholder: String
    },
    model: {
        prop: 'adressObjectId',
        event: 'change'
    },
    data() {
      return {
        adressObjectId: null,
        addressValid: true
      }
    },
    mounted() {
      let app = this;
      let autocompleteInput = this.$refs.autocomplete;

      let onAutocomplete = (event) => {
        autocompleteInput.value = event.target.innerText;
        app.adressObjectId = event.target.dataset.id;
        app.addressValid = true;
        app.$emit('change', app.adressObjectId);
      };

      const autocompleteData = (() => {
        return fetch('/addresses').then(response => response.json()) ?? {};
      })();

      const autocomplete = new autoComplete({
        selector: ".glasfaser-standort-autocomplete",
        placeHolder: this.inputplaceholder,
        data: {
          src: autocompleteData,
          keys: ["standort"],
        },
        resultItem: {
          highlight: {
            render: true,
          },
          element: (item, data) => {
            item.setAttribute("data-id", data.value.id);
          },
        },
        events: {
          input: {
            focus: () => {
              if (autocomplete.input.value.length) 
                autocomplete.start();
            },
            keyup: () => {
              app.adressObjectId = null;
              app.addressValid = false;
              app.$emit('change', null);
            }
          },
          list: {
            mousedown: onAutocomplete,
            click: onAutocomplete
          },
        },
      });

      // disable autofocus on Safari by initially hiding the input and adding it after half a second
      setTimeout(() => {
        autocompleteInput.classList.remove('hidden');
      }, 500);	
    }
}
</script>
